import styled from "styled-components";
import { Container } from "../layout/Container";

const Section = styled.section`
  background: hsl(${({ theme }) => theme.colors.navDark});
  padding: 2.5rem 0;
  text-align: center;
`;

const H1 = styled.h1`
  margin: 0 0 0.5rem;
  font-size: ${({ theme }) => theme.font.heroTitle};
  font-weight: 800;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
`;

const P = styled.p`
  margin: 0;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.65);
  font-size: clamp(0.9375rem, 0.88rem + 0.25vw, 1.125rem);
  max-width: min(100%, 52rem);
  margin-left: auto;
  margin-right: auto;
`;

export default function BlogHero() {
  return (
    <Section>
      <Container>
        <H1>Saving Tips</H1>
        <P>Guides, hacks, and seasonal advice to stretch your budget further.</P>
      </Container>
    </Section>
  );
}
